export function assetUrl(path: string, cacheToken?: string | number): string {
  const version = import.meta.env.VITE_ASSET_VERSION ?? '1';
  const clean = path.startsWith('/') ? path : `/${path}`;
  const token = cacheToken != null && String(cacheToken).trim() !== ''
    ? `&cb=${encodeURIComponent(String(cacheToken))}`
    : '';
  return `${clean}?v=${version}${token}`;
}

export function characterAvatarUrl(refObjId: number | string): string {
  return assetUrl(`/assets/images/character/icon/${refObjId}.webp`);
}

export function raceImageUrl(refObjId: number): string {
  return assetUrl(refObjId < 3000 ? '/assets/images/character/race_china.webp' : '/assets/images/character/race_euro.webp');
}

export const LOGO_LOADING = assetUrl('/assets/images/logos/white-republic-logo.png');

const ITEM_ICON_FALLBACK = '/assets/icons/menu/battlepass.webp';

/**
 * Rutas de medios same-origin para WebView (bloquea CDNs externos).
 * Si la DB guarda URL absoluta de play-republic, usa solo el path /assets/...
 */
export function resolveMediaUrl(
  url: string | null | undefined,
  cacheToken?: string | number,
): string {
  if (!url?.trim()) return assetUrl(ITEM_ICON_FALLBACK);

  let path = url.trim();

  if (/^https?:\/\//i.test(path)) {
    try {
      const parsed = new URL(path);
      path = parsed.pathname;
    } catch {
      return assetUrl(ITEM_ICON_FALLBACK);
    }
  }

  if (!path.startsWith('/')) path = `/${path}`;
  return assetUrl(path, cacheToken);
}

export function itemIconFallbackUrl(): string {
  return assetUrl(ITEM_ICON_FALLBACK);
}
